import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NOOP = () => { };

const TabTitle = (props) => {
  const {
    checked,
    children,
    className,
    onClick,
    onMouseEnterTab,
    onMouseLeaveTab,
    captureRef,
    value
  } = props;
  const titleStyling = classNames(
    className,
    'tab-group__item',
    { selected: checked }
  );

  return (
    <button
      ref={captureRef}
      className={titleStyling}
      onMouseEnter={onMouseEnterTab}
      onMouseLeave={onMouseLeaveTab}
      type="button"
      onClick={onClick}
      value={value}
    >
      {children}
    </button>
  );
};

TabTitle.displayName = 'TabTitle';
TabTitle.propTypes = {
  /** Tab's title */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnterTab: PropTypes.func,
  onMouseLeaveTab: PropTypes.func,
  captureRef: PropTypes.func,
  checked: PropTypes.bool,
  value: PropTypes.number
};

TabTitle.defaultProps = {
  checked: false,
  className: null,
  onClick: NOOP,
  onMouseEnterTab: NOOP,
  onMouseLeaveTab: NOOP,
  captureRef: NOOP,
  value: 0
};

export default TabTitle;
